<template>
  <v-container style="background-color:white;max-width:200mm !important;">
    <page>
      <div :style="'height: 350px'"></div>
      <h1 style="text-align: center">CBM Prognosis Report</h1>
      <h2 v-if="vessels.length == 1" style="text-align: center">
        {{ vessels[0].name }} - {{ vessels[0].imo }} - {{ vessels[0].engine }}
      </h2>
      <div id="reportDetails">
        <div>
          <h3>Generation Date:</h3>&nbsp;<span>{{ creation_date }}</span>
        </div>
        <div>
          <h3>Generation Period:</h3>&nbsp;<span>{{ report_period }}</span>
        </div>
        <div>
          <h3>Requested by:</h3>&nbsp;<span>{{ report_creator }}</span>
        </div>
      </div>
    </page>
    <page>
      <h2>Definitions / Nomenclature</h2>
      <p><b>Standard running hours:</b> Actual running hours, per component, estimated on the basis of signal dependencies obtained from the onboard DCM PC.</p>
      <p><b>Usage-based running hours:</b> Running hours adjusted for operational severity, per component; Calculated as Standard running hours x Component usage factor.</p>
      <p><b>Usage factor:</b> The usage factor for each component (or cylinder of component if resolved per cylinder) is calculated based on the basis of estimated operational severity. The operational severity is evaluated on the basis of component specific algorithms.</p>

      <h3>Key Performance Indicators (KPIs)</h3>
      <p><b>Current “Usage Factor”:</b> The usage factor value of each component (or cylinder of the component if calculated per cylinder) at the time of the automatic report generation.</p>
      <p><b>Average “Usage Factor”:</b> The average usage factor value for each component (or cylinder of the component if calculated per cylinder) is determined as a daily average over the selected time period (first averaged to the day and then across the given time period),  calculated at the time of the automatic report generation (start date / end date).</p>
      <p><b>Delta (Current - Average) “Usage Factor”:</b> The calculated difference between the average and current usage factor per component (or cylinder of component if resolved per cylinder).</p>

      <h3>Remaining Useful Life (RUL)</h3>
      <ul>
        <li><b>Absolute interval:</b> On an absolute basis, indicates the time interval or number of running hours remaining until the predefined maintenance event.</li>
        <li><b>Predicted interval:</b> On a predicted interval basis, indicates the time interval of number of running hours remaining until the predefined maintenance event.</li>
      </ul>
      <br>
      <br>
      <h2>KPI Formulas</h2>
      <p>The various formulas (equations) used to calculate the various KPIs outlined above, can be seen below.</p>

      <h3>Average “Usage Factor”</h3>
      <div style="width: 100%; text-align: center;">
        <img height="50" :src="usage_factor_avg" alt="">
      </div>
      <h3>Delta (Current - Average) “Usage Factor”</h3>
      <div style="width: 100%; text-align: center;">
        <img height="50" :src="delta_usage" alt="">
      </div>
      <h3>Remaining Useful Life (RUL), absolute interval</h3>
      <div style="width: 100%; text-align: center;">
        <img height="50" :src="rul_abs" alt="">
      </div>
      <h3>Remaining Useful Life (RUL), predicted interval</h3>
      <div style="width: 100%; text-align: center;">
        <img height="50" :src="rul_pred" alt="">
      </div>
    </page>
    <CBMEngineView
        v-if="engines==1"
        :components="components"
        :tasks="tasks"
    />
    <CBMEngineView
        v-else v-for="engine in Object.keys(components)"
        :key="engine"
        :engine="engine"
        :components="components[engine]"
        :tasks="tasks[engine]"
    />
  </v-container>
</template>

<script type="text/javascript" src="http://cdn.mathjax.org/mathjax/latest/MathJax.js?config=TeX-AMS-MML_HTMLorMML">
</script>
<script>

import axios from 'axios'
import page from "@/screens/reports/Page.vue";
import {store} from "@/main";
import CBMEngineView from "@/screens/reports/CBM/CBMEngineView.vue";

import {Chart} from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'
import EngineCard from "../../components/EngineCard.vue";

Exporting(Highcharts)

More(Highcharts)

export default {
  name: "CBM",
  components: {
    EngineCard,
    page,
    // Chart,
    Highcharts: Chart,
    CBMEngineView
  },
  data() {
    return {
      creation_date: null,
      report_period: null,
      report_creator: null,
      engines: 1,
      vessels: [],
      components: [],
      tasks: [],
      formula: '$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.$$',
      delta_usage: require('../../assets/cbm/delta_usage_factor_calculation.png'),
      rul_abs: require('../../assets/cbm/rul_abs_calculation.png'),
      rul_pred: require('../../assets/cbm/rul_pred_calculation.png'),
      usage_factor_avg: require('../../assets/cbm/usage_factor_average_calculation.png')
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    init() {
      if (Object.keys(this.$route.params).indexOf('vessel') > -1) {
        this.loadVessel()
      }
    },
    async loadVessel() {
      let info_path = `${store.config.api_location}/reports/cbm/${this.$route.params.vessel}`;

      if (Object.keys(this.$route.params).indexOf('year') > -1
          && Object.keys(this.$route.params).indexOf('quarter') > -1) {

        info_path += `/year/${this.$route.params.year}/quarter/${this.$route.params.quarter}`;
      }

      await axios.get(info_path)
          .then((response) => {
            if (response.data.success) {
              this.engines = response.data.data.vessel.engine_num;
              this.creation_date = response.data.data.report_info.generation_date;
              this.report_period = response.data.data.report_info.generation_period;
              this.report_creator = response.data.data.report_info.requested_by;

              this.vessels = [response.data.data.vessel];
              this.components = response.data.data.components;
              this.tasks = response.data.data.tasks;
            }
          })
          .catch(function () {
          });
    },
  },
  computed: {
    config: function () {
      return store.config;
    }
  },
  watch: {
    config: {
      handler() {
        if (typeof store.config === 'object' && store.config.api_location.length) {
          this.init();
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style>

#reportDetails {
  margin-top: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#reportDetails div {
  width: 500px;
  display: inline-flex;
  align-items: baseline;
}

table {
  text-align: center;
  width: 100%;
}

table thead tr td, table tbody tr td {
  border: 1px solid black;
  border-bottom: 0;
  border-right: 0;
  line-height: 1.75rem;
}

table thead tr td {
  line-height: 2.5rem;
}

table thead tr td:last-of-type, table tbody tr td:last-of-type {
  border-right: 1px solid black;
}

table tbody tr:last-of-type td {
  border-bottom: 1px solid black;
}
</style>